import { Injectable } from '@angular/core';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class DataProviderService {
    // Relativo al origen desde el que se sirvió el front: sirve igual en
    // producción, en erp2 (develop publicado) y en `ng serve` — este último
    // gracias al proxy de proxy.config.json, que redirige /axia-backend.
    //
    // Apuntar a un host fijo (http://192.168.100.4/) rompe el develop publicado:
    // erp2 se sirve por HTTPS, así que el navegador bloquea la llamada por mixed
    // content, y desde fuera de la LAN esa IP privada ni siquiera existe.
    private url = '../';

    constructor() { }

    public getServiceUrl() {
        return this.url + 'axia-backend/public/index.php/api/';
    }

    public getRootUrl() {
        return this.url + 'axia-backend/public/';
    }

    public getServerUrl() {
        return this.url;
    }

    public authHeader() {
        const _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem('token'),
            // 'Authorization': btoa(localStorage.getItem('token')),
        });

        return {headers: _headers};
    }
}
